import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { BsFillBellFill } from "react-icons/bs";
import { FaUserCircle } from "react-icons/fa";
import { IsAuth } from "../../../utils/Auth";
import UserLinks from "./rightNavbar/UserLinks";
import GuestLinks from "./rightNavbar/GuestLinks";

const ProfileNavbar = ({ props }) => {
  return (
    <div>
      <div id="navbar">
        <nav className="navbar navbar-expand-md navbar-dark bg-dark">
          <div className="container-fluid py-3 my-1">
            {/* <Link className='navbar-brand' href='#'>
            Home
          </Link> */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul
                className="navbar-nav me-auto mb-2 mb-lg-0 gap-md-4 navMargin"
                style={{ width: "45%" }}
              >
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    // aria-current='page'
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/about">
                    About Us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/buystakes">
                    Buy Stakes
                  </Link>
                </li>
              </ul>

              <div className="d-block mainLogo">
                <img
                  src={"/assests/Kibilogo.png"}
                  alt="KIBI Sports"
                  className="img-fluid"
                />
              </div>
              <div className="d-flex navMargin">
                <ul className="navbar-nav ms-md-auto mb-2 mb-lg-0 gap-md-4">
                  {IsAuth() ? <UserLinks /> : <GuestLinks />}
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default ProfileNavbar;
